module.exports = __webpack_public_path__ + "media/my_images/meatan-738096b928c798e744ca95c06076253e.svg";